"use strict"; // consider using component approach <ClientOnly></ClientOnly> instead
//
// https://joshwcomeau.com/react/the-perils-of-rehydration/#the-solution

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.browserOnly = void 0;
/**
 *
 *
 * @export
 */

function browserOnly(fn) {
  if (typeof window !== 'undefined') {
    return fn();
  }

  return;
}

exports.browserOnly = browserOnly;